"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export interface HomeTabItem {
  key: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
}

export interface HomeTabsV2Props {
  items: HomeTabItem[];
  value: string;
  onChange: (value: string) => void;
  tone?: "light" | "dark";
}

export function HomeTabsV2({
  items,
  value,
  onChange,
  tone = "dark"
}: HomeTabsV2Props) {
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((item) => {
        const isActive = item.key === value;
        return (
          <button
            key={item.key}
            type="button"
            onClick={() => onChange(item.key)}
            className={cn(
              "rounded-lg border px-4 py-2 text-sm font-medium backdrop-blur transition-colors",
              tone === "dark" &&
                (isActive
                  ? "border-white/40 bg-white/30 text-white"
                  : "border-white/20 bg-white/10 text-blue-50 hover:bg-white/20"),
              tone === "light" &&
                (isActive
                  ? "border-slate-300 bg-slate-100 text-slate-900 dark:border-zinc-700 dark:bg-zinc-800 dark:text-zinc-100"
                  : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50 dark:border-zinc-800 dark:bg-zinc-900 dark:text-zinc-300 dark:hover:bg-zinc-800")
            )}
          >
            {item.icon}
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
